import { DownOutlined } from '@ant-design/icons';
import Cookies from 'universal-cookie';
import type { MenuProps } from 'antd';
import { Dropdown, Menu, message, Space } from 'antd';
import React from 'react';
//import { link } from "fs";
//import {  HashLink as Link } from "react-router-hash-link";
import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";
import Home from "../../pages/Home"
import rillmentConfig from "src/config";
const axios = require('axios').default;
const {HashLink: Link} = require("react-router-hash-link");
// const rHashLink = require("react-router-hash-link");
// const {HashLink} = rHashLink
// const {Link} = HashLink
const cookies = new Cookies();

const onClick: MenuProps['onClick'] = ({ key }) => {

  switch(key) { 
    case '1': { 
       break; 
    } 
    case '2': { 
      console.log("Logout start")
      const csrf_token = localStorage.getItem("csrf_token");
      // backend also tries to delete it
      axios.get('/portal/api/logout',{},
        {headers: {"csrf_token": csrf_token}}
      ).then((response : any) =>{  
        if(response.status == 200){
          console.log("Logout Success")
          cookies.remove('haveLogon', { path: '/portal/'}); // must have path but not domain
          localStorage.removeItem("csrf_token")
          // Back to home to reset states
          window.location.replace("/")
        } else {
          // login or error
          //window.location.replace("/account/profile")
        }
      }).catch((error : any) => {
  
      })
       break; 
    } 
    default: { 

       break; 
    } 
 } 
};

// export const gamesmenu() {
//   <Menu
//     onClick={onClick}
//     items={[
//       {
//         label: 'Cosmic Succubus Evolution',
//         key: '1',
//       },
//       {
//         label: 'Alien Hover Tanks',
//         key: '2',
//       },
//     ]}
//   />
//   };

export const profilemenu = (
  <Menu
    onClick={onClick}
    items={[
      {
        label: <Link to="/account/profile#top" scroll={(el :any) => el.scrollIntoView({ behavior: 'smooth', block: 'center' })}>Account</Link>,
        key: '1',
      },
      {
        label: "Logout",
        key: '2',
      },
    ]}
  />
);